import styled from "styled-components";

export const AsideContainer = styled("div")`
  width: 200px;
  padding: 16px;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: #2c2c2c;
  z-index: 100;
  overflow-y: auto;
  @media (max-width: 768px) {
    transform: translateX(-100%);
    transition: transform 0.25s ease;
    &.mobile-open {
      transform: translateX(0);
    }
  }
`;

export const Logo = styled("div")`
  padding: 8px 12px 20px;
  text-align: center;
  img {
    height: 28px;
    filter: brightness(0) invert(1);
  }
`;

export const CloseBtn = styled("button")`
  display: none;
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  color: #d9d9d9;
  font-size: 24px;
  cursor: pointer;
  line-height: 1;
  @media (max-width: 768px) {
    display: block;
  }
`;
